import React from 'react';
import './AguardoLiberacao.css';

const AguardoLiberacao = () => {
  return (
    <div className="aguardo-container">
      <div className="aguardo-card">
        <div className="aguardo-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#4CAF50" strokeWidth="2"/>
            <path d="m9 12 2 2 4-4" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="aguardo-title">Cadastro Realizado com Sucesso!</h1>
        
        <p className="aguardo-message">
          Seu cadastro foi enviado para análise. Você receberá um e-mail de confirmação 
          assim que seu acesso for liberado pela equipe responsável.
        </p>
        
        <div className="aguardo-info">
          <div className="info-item">
            <strong>Próximos passos:</strong>
            <ul>
              <li>Aguarde o e-mail de confirmação</li>
              <li>Verifique sua caixa de entrada e spam</li>
              <li>O processo pode levar até 24 horas</li>
            </ul>
          </div>
        </div>
        
        <div className="aguardo-actions">
          <button 
            className="btn-voltar-login"
            onClick={() => window.location.href = '/login'}
          >
            Voltar para Login
          </button>
        </div>
        
        <div className="aguardo-footer">
          <p>
            Dúvidas? Entre em contato com nosso suporte: 
            <a href="mailto:suporte@empresa.com" className="support-link">
              suporte@empresa.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AguardoLiberacao;
